<template>
<header :class="headerStyle">
    <div class="row large-9 large-centered">
       <img class="header" :src="headerFile" alt="">
    </div>
</header>
</template>

<script>
import store from '../store/index.js'
import { mapGetters } from 'vuex'

export default {
  name: 'top',
  computed:
  {
    ...mapGetters([
      'activatedClub'
    ]),
    headerStyle () {
      if ((this.activatedClub === null) || (this.activatedClub === undefined)) {
        return 'headerbordeaux'
      }
      if (this.activatedClub.id === 1) {
        return 'headercognac'
      }
      if (this.activatedClub.id === 2) {
        return 'headercondate'
      }
      if (this.activatedClub.id === 3) {
        return 'headerbordeaux'
      }
      if (this.activatedClub.id === 4) {
        return 'headerkorrigan'
      }
    },
    headerFile () {
      if (this.activatedClub === null) {
        return '/static/imgs/header-gen.jpg'
      }
      return this.activatedClub.banner_path
    }
  },
  methods: {
    exit () {
      store.dispatch('logOut')
      this.$router.push({name: 'Home'})
    }
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div .header {
    padding: 0.3rem 0rem;
}

.header {
    margin: 1rem 0rem;
}

.headerbordeaux{
    background-color: #fff;
}
.headerkorrigan{
    background-color: #930b0b;
}
.headercondate{
    background-color: #930b0b;
}
.headercognac{
    background-color: #e8ecef;
}
</style>



// WEBPACK FOOTER //
// top.vue?484dec7e